// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__195el","navigateBefore":"styles_navigateBefore__cZv8H","editAttributes":"styles_editAttributes__12-SQ"};